module.exports = __webpack_public_path__ + "static/Santiago-jimenez-161af4a9595c94bf498598781f2ca214.png";